import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const getSuggestedTopicsIds = createSelector(
  (state: RootState) => state.domains.suggestedTopics.ids,
  (state: RootState) => state.entities.topics.following.ids,
  (suggestedTopicsIds, topicsFollowingIds) => suggestedTopicsIds.filter((item) => !topicsFollowingIds.includes(item)),
);

export const createSuggestedTopicsSelector = (ids: string[]) =>
  createSelector(
    ...ids.map((id) => (state: RootState) => state.domains.suggestedTopics.data[id]),
    (...suggestedTopics) => suggestedTopics,
  );

export const getIsSuggestionsPending = (state: RootState) => state.domains.suggestedTopics.isPending;
